<template>
  <div class="page">
    <div class="card">
      <div class="topbar">
        <div>
          <h1 class="title">Seguranca do trabalho</h1>
          <p class="subtitle">Submissoes de seguranca e documentos criticos.</p>
        </div>
        <div class="topbar-right">
          <button class="btn btn-ghost" type="button" @click="goHome">Inicio</button>
          <button class="btn btn-ghost" type="button" @click="logout">Sair</button>
          <button class="icon-btn" type="button" @click="toggleCreate">+</button>
        </div>
      </div>

      <div v-if="showCreateOptions" class="item-card" style="margin-bottom: 16px;">
        <div class="grid" style="gap: 10px;">
          <button class="btn btn-ghost" type="button" @click="goDialogo">Dialogos de Seguranca</button>
          <button class="btn btn-ghost" type="button" @click="goPermissao">Permissao de Trabalho Critico</button>
          <button class="btn btn-ghost" type="button" @click="goOcorrido">Relatorio de Ocorrido</button>
        </div>
      </div>

      <div v-if="items.length === 0" class="item-card">
        <h3 class="item-title">Nenhuma submissao por aqui</h3>
        <p class="item-meta">Clique no + para criar o primeiro documento.</p>
      </div>

      <div v-else class="grid card-list">
        <div v-for="item in items" :key="item.id" class="item-card">
          <div>
            <h3 class="item-title">
              {{ item.title }} - {{ item.attraction }} - {{ formatReportDate(item.reportDate) }}
            </h3>
            <div class="item-meta">
              {{ formatDate(item.createdAt) }} - {{ item.status === 'rascunho' ? 'Rascunho' : 'Enviado' }}
            </div>
          </div>
          <div class="actions">
            <button class="btn btn-secondary" type="button" @click="view(item.id)">Visualizar</button>
            <button class="btn btn-ghost" type="button" @click="edit(item.id)">Editar</button>
            <button class="btn btn-accent" type="button" @click="remove(item.id)">Excluir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { sessionStore } from '@/store/session'
import { submissionsStore } from '@/store/submissions'
import { formatDateOnly, formatDateTime } from '@/utils/date'
import { uiStore } from '@/store/ui'

const safetyTypes = [
  'Dialogos de seguranca',
  'Permissao de trabalho critico',
  'Relatorio de ocorrido'
]

export default defineComponent({
  name: 'SafetySubmissionsView',
  setup() {
    const router = useRouter()
    const user = computed(() => sessionStore.state.user)

    const items = computed(() => {
      if (!user.value) return []
      const all = submissionsStore.all().filter((item) => safetyTypes.includes(item.title))
      if (user.value.role === 'admin-master' || user.value.role === 'admin-obra') {
        return all
      }
      return all.filter((item) => item.author.name === user.value?.name)
    })

    const showCreateOptions = ref(false)

    const toggleCreate = () => {
      showCreateOptions.value = !showCreateOptions.value
    }

    const goDialogo = () => {
      showCreateOptions.value = false
      router.push('/safety/dialogo')
    }
    const goPermissao = () => {
      showCreateOptions.value = false
      router.push('/forgot')
    }
    const goOcorrido = () => {
      showCreateOptions.value = false
      router.push('/safety/ocorrido')
    }
    const view = (id: string) => {
      const item = submissionsStore.getById(id)
      if (item?.category === 'relatorio') {
        router.push(`/submission/${id}`)
        return
      }
      router.push(`/safety/${id}`)
    }
    const edit = (id: string) => {
      const item = submissionsStore.getById(id)
      if (item?.category === 'dialogo') {
        router.push(`/safety/dialogo/${id}`)
        return
      }
      if (item?.category === 'ocorrido') {
        router.push(`/safety/ocorrido/${id}`)
        return
      }
      if (item?.category === 'permissao') {
        router.push('/forgot')
        return
      }
      router.push(`/submission/${id}/edit`)
    }

    const remove = async (id: string) => {
      if (!await uiStore.confirm('Excluir esta submissao?')) return
      await submissionsStore.deleteSubmission(id)
    }

    const logout = () => {
      sessionStore.logout()
      router.push('/login')
    }

    const goHome = () => router.push('/home')

    onMounted(() => {
      submissionsStore.refresh().catch(() => {
        // ignore for now
      })
    })

    return {
      items,
      formatDate: formatDateTime,
      formatReportDate: formatDateOnly,
      showCreateOptions,
      toggleCreate,
      goDialogo,
      goPermissao,
      goOcorrido,
      view,
      edit,
      remove,
      logout,
      goHome
    }
  }
})
</script>
